import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';
import styled from 'styled-components';
import {ColorThemePalette} from './ColorThemePalette';
import {formControlColors} from '../componentColors/formControlVariableColors';
import {CardColors} from '../componentColors/cardVariableColors';

export const ColorThemeContainerStates = styled(ColorThemePalette)`
    ${colorTheme({
        // // ==== Hover === // //
        // // -------------- // //
        '--container-background-hover-color-100   ': {dark: 'var(--blue-13)       ', light: 'var(--blue-02)'},
        '--container-background-hover-color-200   ': {dark: 'var(--primary)       ', light: 'var(--blue-02)'},
        '--container-background-hover-color-300   ': {dark: 'var(--blue-13)       ', light: 'var(--blue-01)'},

        '--container-border-hover-color-100   ': {dark: 'var(--blue-15)       ', light: 'var(--primary)'},

        // // ==== Active === // //
        // // --------------- // //
        '--container-background-active-color-100': {dark: 'var(--blue-prime)', light: 'var(--blue-06)'},
        '--container-background-active-color-200': {dark: 'var(--blue-13)   ', light: 'var(--blue-01)'},
        '--container-background-active-100         ': {dark: '#f4fbff                  ', light: 'var(--blue-00)'},
        '--container-background-active-300         ': {dark: '#C3EAFF                  ', light: 'var(--blue-05)'},

        '--container-shadow-active-100         ': {
            dark: 'var(--shadow-blue-06)',
            light: 'var(--shadow-blue-06)',
        },
        '--container-shadow-active-200         ': {
            dark: 'var(--shadow-dark-05)',
            light: 'var(--shadow-blue-06)',
        },

        '--container-text-color-active-100         ': {
            dark: 'var(--blue-01)                  ',
            light: 'var(--blue-prime)',
        },

        '--container-text-color-active-200          ': {
            dark: 'var(--primary)                  ',
            light: 'var(--primary-dark)',
        },
    })};

    ${formControlColors}
    ${CardColors}
`;
